import React, { useState, useEffect } from 'react'
import styles from './styles'
import { withStyles, Typography } from '@material-ui/core'
import { Icon } from '@iconify/react'
import { CoreButton, CoreIconButton } from 'src/components/core'
import { QuestionFieldNames } from 'src/model/card'
import {
  useCardSettings,
  createSetting,
  patchSetting,
} from 'src/hooks/useCardSettings'
import { useDispatch } from 'react-redux'
import { guid } from 'src/utils/guid'
import ModalContent from './popup'
import translator from 'src/translate'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
const has = numeric => {
  if (numeric == 0) return true

  return numeric ? true : false
}
const ResultCardView = props => {
  const { classes, cardData, isCardResultCard } = props
  const dispatch = useDispatch()
  const [componentBoxContent, setComponentBoxContent] = useState(false)

  const settings = useCardSettings(QuestionFieldNames.RESULT_CONDITIONS)
  const resultConditions = settings ? JSON.parse(settings.value) : undefined

  useEffect(() => {
    if (!resultConditions && cardData && isCardResultCard) {
      createSetting(
        dispatch,
        cardData.id,
        QuestionFieldNames.RESULT_CONDITIONS,
        JSON.stringify([]),
      )
    }
  }, [resultConditions, cardData, isCardResultCard])

  const saveCondition = data => {
    if (!settings) return
    const settingId = settings.id

    patchSetting(
      dispatch,
      cardData.id,
      settingId,
      QuestionFieldNames.RESULT_CONDITIONS,
      JSON.stringify(data),
    )
    dispatch(messageBoxHideAction())
    setComponentBoxContent(false)
  }

  const handleOpenPopup = (id, header) => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: `<div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
            "
          >
            
            <Typography
              style="
                font-size: 1.25rem;
                font-weight: 600;
              "
            >${
              has(id) ? header : translator._('taskItem.resultCard.conditions')
            }</Typography>
          </div>`,
          component: (
            <ModalContent
              {...props}
              conditions={resultConditions}
              conditionId={id}
              key={guid.uid}
              actionType={has(id) ? 'edit' : 'add'}
              saveCondition={saveCondition}
            />
          ),
          draggable: false,
          callback: () => {
            // You can keep your original callback logic here
          },
        }),
      ),
    )
  }

  const prepareDeleteCondition = conditionId => {
    // The index, not the click event: handed the event, splice coerced it to 0 and every delete
    // button removed the first condition.
    let conditions = [...resultConditions]
    conditions.splice(conditionId, 1)
    return saveCondition(conditions)
  }

  return (
    <div className={classes.wrapper}>
      {resultConditions && resultConditions.length > 0 ? (
        <div className={classes.emptyStateContainer}>
          <div className={classes.centerWrapper}>
            {resultConditions.map((value, index) => {
              const header = `${value.type} ${value.condition} ${value.value}`
              return (
                <div className={classes.conditionContainer}>
                  <CoreButton
                    variant="outlined"
                    onClick={() => handleOpenPopup(index, header)}
                    fullWidth
                  >
                    {header}
                  </CoreButton>
                  <CoreIconButton
                    aria-label="delete"
                    variant="outlined"
                    onClick={() => prepareDeleteCondition(index)}
                    size="small"
                    color="secondary"
                  >
                    <Icon icon="mdi:delete" />{' '}
                  </CoreIconButton>
                </div>
              )
            })}
            <CoreButton
              variant="contained"
              color="info"
              startIcon={<Icon icon="uil:plus" />}
              onClick={() => handleOpenPopup()}
              fullWidth
            >
              Add new condition
            </CoreButton>
          </div>
        </div>
      ) : (
        <div className={classes.emptyStateContainer}>
          <Typography className={classes.emptyStateTitle}>
            Your conditions
          </Typography>
          <div className={classes.infoContainer}>
            <Icon icon="ic:round-info" className={classes.infoIcon} />
            <Typography className={classes.infoText}>
              You must add at least 1 condition for this card to work.
            </Typography>
          </div>
          <div className={classes.buttonContainer}>
            <CoreButton
              variant="contained"
              color="info"
              fullWidth
              startIcon={<Icon icon="uil:plus" />}
              onClick={() => handleOpenPopup()}
            >
              Add condition
            </CoreButton>
          </div>
        </div>
      )}
    </div>
  )
}

export default withStyles(styles)(ResultCardView)
